<template>
  <div
    class="navigation-box"
    :style="{ backgroundColor: `#${organizationDetails.lightBrandColor}` }"
    @click="$emit('click')"
  >
    <div class="copy">
      <p class="title">{{ title }}</p>
      <p class="description">{{ description }}</p>
    </div>
    <img class="icon" :src="require('../assets/icons/expand-icon.png')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavigationBox',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.navigation-box {
  display: flex;
  flex-direction: row;
  width: 100vw;
  max-width: $maximum-width;
  padding: 1rem 2rem;
  align-items: center;
  cursor: pointer;
}
.copy {
  display: flex;
  flex-direction: column;
}
.title {
  font-weight: 400;
  font-family: 'Poppins-Medium';
}
.icon {
  height: 4rem;
  width: 4rem;
  transform: rotate(270deg);
}
</style>
